// Cores de identidade das três seções do app (ver
// ae-app/lib/data/models/quiz_list_data.dart) — cada uma tem um par
// escuro/claro (mesmo gradiente usado lá). `onLight` é o tom escuro
// canônico (o mesmo usado sozinho, sem gradiente, em outras telas do app) —
// tem bom contraste no tema claro do backoffice. `onDark` é o tom mais claro
// do início do gradiente — o tom escuro canônico fica sem contraste nenhum
// contra o fundo já bem escuro dos temas dark do backoffice.
const CATEGORY_COLORS = {
    module: { onLight: '#043C58', onDark: '#076492' },
    test: { onLight: '#0C5D56', onDark: '#0D9488' },
    practiceTest: { onLight: '#641BA3', onDark: '#9333EA' },
};

const NEUTRAL_COLOR = '#9E9E9E';

// `category` é 'module' | 'test' | 'practiceTest'; `colorMode` é
// 'light' | 'dark' (mesmo valor de useTheme().layoutColorMode).
export const categoryColor = (category, colorMode) =>
    CATEGORY_COLORS[category]?.[colorMode === 'dark' ? 'onDark' : 'onLight'] || NEUTRAL_COLOR;
